<template>
  <div>
    <v-app-bar app clipped-left dense flat>
      <v-app-bar-nav-icon @click="toggleMinivariant" class="hidden-md-and-down"></v-app-bar-nav-icon>
      <v-app-bar-nav-icon @click="toggleDrawer" class="hidden-lg-and-up"></v-app-bar-nav-icon>
      <v-layout align-center>
        <a @click="goTo('/')">
          <!-- <img alt="Farmet Platform Logo" contain :src="require('../assets/logo_fp-white.png')" transition="scale-transition" width="40" height="40" class="mr-2" /> -->
        </a>
        <v-toolbar-title class="ml-3 font-weight-bold hidden-md-and-down">Zambezi Farmer Dashboard</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-text-field class="grey lighten-2 pr-2" dense placeholder="search" hide-details solo-inverted append-outer-icon="search" flat />

        <v-spacer></v-spacer>
        <v-menu offset-y offset-x origin="top center" :nudge-bottom="12" :nudge-width="200" transition="scale-transition">
          <template v-slot:activator="{ on }">
            <!-- slot="activator"> -->
            <v-btn icon large v-on="on">
              <v-avatar size="30px">
                <v-icon>person</v-icon>
              </v-avatar>
            </v-btn>
          </template>
          <v-list class="pa-0">
            <v-list-item v-for="(item, index) in profileItems" :to="!item.href ? { name: item.name } : null" :href="item.href" @click="item.click" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- <v-btn v-for="(item, index) in menuItems" :key="index" :to="item.link" class="hidden-xs-only" large tile text>{{item.title}}</v-btn> -->
      </v-layout>
    </v-app-bar>

    <v-navigation-drawer clipped :mini-variant="miniVariant" class="hidden-md-and-down" :width="200" app>
      <v-layout align-center>

        <v-spacer></v-spacer>
        <a @click="goTo('/')">
          <!-- <img alt="Farmet Platform Logo" contain :src="require('../assets/logo_fp-white.png')" transition="scale-transition" width="40" height="40" /> -->
        </a>
        <v-spacer></v-spacer>
      </v-layout>

      <v-list>
        <v-list-item v-for="(item, index) in menuItems" :key="index" @click="goTo(item.link)">
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            {{ item.title }}
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
      </v-list>
      <template v-slot:append>
        <div class="my-4 mr-4 text-right">
          <v-icon normal @click="toggleMinivariant">{{toggleIcon}}</v-icon>
        </div>
      </template>
    </v-navigation-drawer>

    <v-navigation-drawer clipped v-model="drawer" class="hidden-lg-and-up" fixed :width="200" app>
      <v-layout align-center>

        <v-spacer></v-spacer>
        <a @click="goTo('/')">
          <!-- <img alt="Farmet Platform Logo" contain :src="require('../assets/logo_fp-white.png')" transition="scale-transition" width="40" height="40" /> -->
        </a>
        <v-spacer></v-spacer>
      </v-layout>

      <v-list>
        <v-list-item v-for="(item, index) in menuItems" :key="index" @click="goTo(item.link)">
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            {{ item.title }}
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
      </v-list>
      <template v-slot:append>
        <div class="my-4 mr-4 text-right">
          <v-icon normal @click="toggleDrawer">keyboard_arrow_left</v-icon>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
// import { store } from '@/store'
import { mapGetters } from 'vuex'
// import router from '@/router'

export default {
  data() {
    return {
      miniVariant: false,
      drawer: false,
      profileItems: [
        // {
        //   icon: 'account_circle',
        //   title: 'Profile',
        //   click: () => router.push('/profile')
        // },
        // {
        //   icon: 'settings',
        //   title: 'Settings',
        //   click: () => router.push('#')
        // },
        { icon: 'exit_to_app', title: 'Logout', click: () => { this.onLogout() } }
      ]
    }
  },
  // beforeMount() {
  //   this.user = store.getters.user()
  // },
  computed: {
    ...mapGetters(['user']),
    menuItems() {
      // use 'let' to assign different menu for authenticated users
      const menuItems = [{ icon: 'storefront', title: 'Visit Store', link: '/' }]
      if (this.user?.isAdmin) {
        menuItems.unshift({ icon: 'person', title: 'Suppliers', link: '/suppliers' })
      } else {
        menuItems.unshift({ icon: 'business', title: 'Products', link: '/my-products' })
      }
      return menuItems
    },
    toggleIcon() {
      if (this.miniVariant) {
        return 'keyboard_arrow_right'
      } else {
        return 'keyboard_arrow_left'
      }
    }
  },
  watch: {
    user() {
      // use 'let' to assign different menu for authenticated users
      if (this.user.isAdmin) {
        this.menuItems.push({
          icon: 'person',
          title: 'Suppliers',
          link: '/suppliers'
        })
      }
      // this.menuItems = items
    }
  },
  methods: {
    onLogout() {
      this.$store.dispatch('logout')
    },
    goTo(path) {
      const currentPath = this.$router.currentRoute.path
      if (currentPath !== path) this.$router.push(path)
    },
    toggleDrawer() {
      this.drawer = !this.drawer
    },
    toggleMinivariant() {
      this.miniVariant = !this.miniVariant
    }
  }
}
</script>
